module.exports = __webpack_public_path__ + "img/icon-mail-wide.ea9c8ece.svg";